import { useLocation, useParams, useSearchParams } from 'react-router';
import { useSession } from '@/stores/session';
import { NoAccess } from '../shipments/ListParts';
import { ExceptionDetail } from './ExceptionDetail';
import type { ExceptionItem } from './types';

/** /exceptions/:id?order=<orderId> —— 老系统没有按 id 取异常的接口，用订单号过滤后按 id 找 */
export function ExceptionDetailPage() {
  const { id = '' } = useParams();
  const [sp] = useSearchParams();
  const seed = (useLocation().state as { seed?: ExceptionItem } | null)?.seed;
  const can = useSession((st) => st.can);
  if (!can('exceptions.read')) return <NoAccess what="异常售后" legacy="/order-exceptions" />;
  const action = sp.get('action');
  const requestedAction = action === 'close' || action === 'resolve' ? action : undefined;
  return <ExceptionDetail key={id} id={id} orderId={sp.get('order') || undefined} seed={seed} requestedAction={requestedAction} />;
}
